export default __webpack_public_path__ + "static/media/tete16.4a7332b9.png";